<template>
  <ul :class="['divide-y divide-gray-100', dense ? '' : '']">
    <slot />
  </ul>
</template>

<script setup lang="ts">
/** UiList — Vuetify <v-list> replacement. */
withDefaults(defineProps<{ dense?: boolean }>(), { dense: false })
</script>
